import classNames from 'classnames';
import Typography from 'src/components/common/typography/Typography';
import Button from 'src/components/button/Button';
import Card from 'src/components/common/card/Card';
import userImg from '../../../assets/images/companylogo/YLAC.png'
import userProfile from '../../../assets/images/svg/userProfiles.svg'

import './actionCard.scss';
import { TActionCardProps } from './actionCard.types';
import { TUser } from 'src/services/apiEndpoint.types.ts';
import { useAppSelector } from 'src/store/hooks';
import { ProfilePicture } from 'src/components/common';
import { textFormatter } from 'src/utils';
import TopUserProfile from './TopUserProfile';
import { useNavigate } from 'react-router-dom';

const ActionCard = ({
  title,
  description,
  buttonText,
  className,
  onClick,
  ...rest
}: TActionCardProps) => {
  const navigate = useNavigate()
  const { topUsersCompany } = useAppSelector((store) => store.socialMedia);
  const { profile } = useAppSelector((store) => store.profile);
  const topUsers = topUsersCompany?.inviteConnections?.slice(0, 3);
  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };
  function handleRedirect (id:string) {
    navigate(profile?.id === id ? '/my-profile': `/view-profile?id=${id}`)
  }
  return (
    <Card className={classNames('action-card', className)} {...rest}>
      <Typography as="p" variant="body-1" fontWeight="semiBold">
        {title}
      </Typography>{' '}
      <Typography as="p" variant="body-3" fontWeight="regular">
        {description}
      </Typography>
      <div className='action-card__userImgs'>
        <ul>
          {topUsers?.map((item: TUser, i: number) => {
            return (
              <li key={i} style={i === 0 ? { marginLeft: '0' } : {}}>
                <TopUserProfile url={item.profilePic} name={item?.name} onClick={(e) => handleRedirect(item.userId)} fallback={textFormatter({ value: item?.name?.[0] })} />
              </li>
            )
          })}
          <li>
            <img src={userProfile} alt="user" />
          </li>
        </ul>
      </div>
      <Button size="small" variant="secondary" onClick={handleClick}>
        {buttonText}
      </Button>
    </Card>
  );
};

export default ActionCard;
